function onUnwrap(evt) {
	Array.prototype.forEach.call(this.querySelectorAll('.params-list__lbl'), showEl);
	Array.prototype.forEach.call(this.querySelectorAll('.params-list__val'), showEl);
	hideEl(this.querySelector('.params-list__unwrap'));
}

function hideEl(el) {
	el.style.display = 'none';
}

function showEl(el) {
	el.style.display = el.tagName === 'A' ? 'inline' : 'block';
}

function capitalizeWord(word) {
	return word.charAt(0).toUpperCase() + word.slice(1);
}

function makeSummary(lbls) {
	return capitalizeWord(lbls.map((lbl) => lbl.textContent).join(', ').toLowerCase());
}

function initList(list) {
	var show = parseInt(list.dataset && list.dataset.show, 10) || null;
	if(show === null) {
		return;
	}
	var unwrap = list.querySelector('.params-list__unwrap');
	var lbls = Array.prototype.slice.call(list.querySelectorAll('.params-list__lbl'), show);
	var vals = Array.prototype.slice.call(list.querySelectorAll('.params-list__val'), show);

	lbls.forEach(hideEl);
	vals.forEach(hideEl);

	if(lbls.length) {
		showEl(unwrap);
		unwrap.querySelector('span').textContent = makeSummary(lbls);
		unwrap.addEventListener('click', onUnwrap.bind(list));
	}
}

module.exports = function() {
	var lists = document.querySelectorAll('.params-list');

	Array.prototype.forEach.call(lists, initList);
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/params-list.js
 **/